var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('router-view',{staticClass:"mt-10"}),_c('modal-categories',{attrs:{"dialog":_vm.categoriesDialog},on:{"closeDialog":function($event){_vm.categoriesDialog = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }